import styled from 'styled-components';

export const TableFormStyle = styled.div`
  td:first-child {
  }
  .box-form {
    display: flex;
    flex-direction: row;
    margin-right: 0.5px;
    input {
    }
    .ant-select {
      width: 80px;
      height: 32px;

      &.warning {
        border: 1px solid red;
        color: red;
      }
      &.ant-select-disabled {
        color: black;
        background-color: #f5f5f5;
        border-color: #1c4b8c;
        box-shadow: none;
        cursor: not-allowed;
        opacity: 1;
        .ant-select-selection-item{
          color: black!important
        }
      }
      }
    }
    .ant-input {
      color: black;
      width: 42px;
      height: 32px;
      min-width: 45px;
      margin-left: 16px;
    }
    .box-unit {
      display: flex;
      align-items: flex-end;
      margin-left: 4px;
      min-width: 30px;
      font-weight: 400;
    }
  }
`;
